<script lang="ts" setup>
import { Studio } from '@/modules/Studios/types'
import { useImage } from '@/shared/composables/image'

const { getOrgImage } = useImage()
defineProps<{
  studio: Studio
}>()
</script>

<template>
  <div class="studio">
    <v-card
      :to="{ name: 'Studio', params: { id: studio.id } }"
      class="studio-card"
    >
      <v-img
        :src="getOrgImage(studio.image, 600)"
        :alt="studio.name"
        class="image"
      />
    </v-card>
    <span class="studio-name">
      {{ studio.name }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.studio {
  width: 100%;
  max-width: 305px;
  margin: 0 auto;

  .studio-card {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    border-radius: var(--border-radius-rounded) !important;
  }

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.studio-name {
  display: block;
  margin-top: 8px;
  color: var(--color-white);
  font-weight: var(--font-weight-bold);
  text-align: center;
}
</style>
